import { isUserManager, isUserVolunteer } from "@shared/Utils";
import LoadingElement from "@shared/components/LoadingElement";
import { RouteNames } from "@shared/entities/RouteNames";
import { useQueryParam } from "@shared/hooks/queryParam";
import { useAuthService } from "@shared/services";
import { useConfigService } from "@shared/services/ConfigService";
import {
  useRegistrationService,
} from "@shared/services/RegistrationService";
import { lazy, Suspense, useEffect, useMemo, useState } from "react";
import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";

const Lazy = {
  Register: lazy(() => import("./pages/Register/RegisterRouter")),
  Login: lazy(() => import("./pages/Login")),
  Dashboard: lazy(() => import("./pages/Dashboard")),
  RegisterEvent: lazy(() => import("./pages/RegisterEvent")),
  Backend: lazy(() => import("./pages/Backend")),
  Volunteer: lazy(() => import("./pages/Volunteer")),
  A: lazy(() => import("./pages/AAAAAA")),
  Meow: lazy(() => import("./pages/Meow")),
};

export default function AppRouter() {
  const { user } = useAuthService();
  const location = useLocation()
  const navigate = useNavigate()
  const { isRegisterOpen, onsiteRegistrationToken } = useConfigService()
  const queryParam = useQueryParam<{ token: string }>()
  const { registration } = useRegistrationService();
  const [redirectPath, setRedirectPath] = useState<string>()

  const canActiveLogin = useMemo(() => {
    return !user;
  }, [user]);

  const canActiveRegisterEvent = useMemo(() => {

    // 彩蛋用
    if (location.pathname.includes('setup')) {
      return true;
    }

    // 未登入時阻擋
    if (!user) {
      return false;
    }

    // 已報名時阻擋
    if (registration) {
      return false;
    }

    // 有token的情況下不限時間也可以報名
    // TODO: 現場報名token阻擋？
    return (isRegisterOpen || queryParam?.token);
  }, [location.pathname, user, registration, isRegisterOpen, queryParam?.token]);

  const canActiveBackend = useMemo(() => {
    return isUserManager(user)
  }, [user]);

  const canActiveVolunteer = useMemo(() => {
    return isUserVolunteer(user)
  }, [user]);

  // 如果未登入，且網址路由資訊是在登入後的位置時，記憶為登入後跳轉位置
  useEffect(() => {
    if (!user) {
      if (!redirectPath) {
        setRedirectPath(location.pathname + location.search)
      }
    } else if (redirectPath) {
      navigate(redirectPath)
      setRedirectPath(null)
    }

  }, [user, location, redirectPath, navigate, onsiteRegistrationToken])
  return (
    <Suspense fallback={<LoadingElement />}>
      <Routes>
        {/* 註冊頁 */}
        {canActiveLogin ? (
          <>
            <Route
              path={`/${RouteNames.Register}/*`}
              element={<Lazy.Register />}
            />
            {/* 登入頁 */}
            <Route path={`/${RouteNames.Login}/*`} element={<Lazy.Login />} />
          </>
        ) : (
          <>
            {/* 內頁 */}
            <Route
              path={`/${RouteNames.Dashboard}/*`}
              element={<Lazy.Dashboard />}
            />
            {/* 活動報名頁 */}
            {canActiveRegisterEvent && (
              <Route
                path={`/${RouteNames.RegisterEvent}/*`}
                element={<Lazy.RegisterEvent />}
              />
            )}
          </>
        )}
        {canActiveBackend && (
          /* 後端 */
          <Route path={`/${RouteNames.Backend}/*`} element={<Lazy.Backend />} />
        )}
        {canActiveVolunteer &&
          /* 志工頁 */
          <Route path={`/${RouteNames.Volunteer}/*`} element={<Lazy.Volunteer />} />
        }
        {/* AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA */}
        <Route path={`/${RouteNames.A}/*`} element={<Lazy.A />} />
        {/* meow */}
        <Route path={`/${RouteNames.Meow}/*`} element={<Lazy.Meow />} />
        {/* 自動跳轉 */}
        <Route
          path="/*"
          element={
            canActiveLogin ? (
              <Navigate replace to={`/${RouteNames.Login}/`} />
            ) : (
              <Navigate replace to={`/${RouteNames.Dashboard}/`} />
            )
          }
        />
      </Routes>
    </Suspense>
  );
}
